import PropTypes from "prop-types";
import styled from "@emotion/styled";
import {
  AppBar,
  Box,
  IconButton,
  InputAdornment,
  TextField,
  Toolbar,
  Tooltip,
  OutlinedInput,
  Badge,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import AccountPopover from "./AccountPopover";
import InputControl from "./InputControl";
import { useContext } from "react";
import { AuthContext } from "../../store/AuthProvider";
import { useLocation } from "react-router-dom";
import { arraySort } from "../../utils";
import { Stack } from "immutable";
import NavbarNotification from "./NavbarNotification";

const DashboardNavbarRoot = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[3],
}));

export const DashboardNavbar = (props) => {
  const { pathname } = useLocation();
  const isStoreAdmin = pathname.includes("store-admin");
  const { onSidebarOpen, open, ...other } = props;
  const {
    auth: {
      data: { stores, selectedStoreId },
    },
    setAuth,
  } = useContext(AuthContext);

  const storeList = stores.map((item) => ({
    label: item.name,
    value: item.id,
  }));

  const onStoreChange = (e) => {
    const { value } = e;
    setAuth((draft) => {
      draft.data.selectedStoreId = value;
    });
    window.location.href = pathname;
  };

  const getBadgeContent = () => {

    const envKey = process.env.REACT_APP_SENTRY_ENV_KEY;
    switch (envKey) {
      case "production":
        return null;
      case "multitenant":
        return null;
      case "staging2":
        return "QA";
      case "beta":
        return "BETA";
      default:
        return "DEV";
    }
  };

  return (
    <>
      <DashboardNavbarRoot
        sx={{
          boxShadow: "none !important",
          left: {
            lg: open && 280,
          },
          width: {
            lg: open ? "calc(100% - 280px)" : "100%",
          },
        }}
        {...other}
      >
        <Toolbar
          disableGutters
          sx={{
            minHeight: 64,
            left: 0,
            px: 2,
          }}
        >
          <IconButton
            onClick={onSidebarOpen}
            sx={{
              display: {
                xs: "inline-flex",
              },
            }}
          >
            <MenuIcon fontSize="small" />
          </IconButton>

          {/* <OutlinedInput
            placeholder="Search"
            sx={{
              height: "44px",
              background: "#f7f7f7",
              pl: "10px",
              "& input": { pl: "0px !important" },
              "& fieldset": { border: "none" },
            }}
            size="small"
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon size="large" />
              </InputAdornment>
            }
          /> */}
          <Box sx={{ flexGrow: 1 }} />
          {/* <Tooltip title="Notifications">
            <IconButton
              size="large"
              sx={{
                ml: 1,
                mr: "12px",
                background: "#f7f7f7",
                borderRadius: "8px",
                "&:hover": { background: "#e6e6e6" },
              }}
            >
              <NotificationsRoundedIcon
                fontSize="small"
                sx={{
                  color: "#000",
                }}
              />
            </IconButton>
          </Tooltip> */}
          {isStoreAdmin && (
            <InputControl
              type="dropdown"
              style={{ width: 183 }}
              options={arraySort(storeList || [], "label")}
              disableClearable
              value={
                (storeList?.length > 0 &&
                  selectedStoreId &&
                  storeList.find((item) => item.value === selectedStoreId)) ||
                null
              }
              includeInputInList
              onChange={(e, value) => onStoreChange(value)}
              filterSelectedOptions
              sx={{
                "& input": { px: "0px !important" },
                "& fieldset": { border: "none" },
              }}
              renderOption={(props, option) => {
                return (
                  <Box
                    component="li"
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    <img
                      alt="store icon"
                      loading="lazy"
                      width="20"
                      src="/icons/ic_store.svg"
                    />
                    {option.label}
                  </Box>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  sx={{
                    backgroundColor: "rgba(0, 0, 0, 0.03)",
                    borderRadius: "8px",
                    ".MuiInputBase-root": { height: "44px" },
                  }}
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <InputAdornment position="start">
                        <img alt="store icon" src="/icons/ic_store.svg" />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          )}
          <IconButton sx={{ ml: 1 }}>
            <NavbarNotification />
          </IconButton>

          <IconButton sx={{ ml: 1 }}>
            <Badge
              badgeContent={getBadgeContent()}
              color="error"
              sx={{
                '& .MuiBadge-badge': {
                  fontSize: '0.6rem',
                  height: '16px',
                  minWidth: '28px',
                  borderRadius: '8px',
                  fontWeight: 'bold',
                }
              }}
            >
              <AccountPopover />
            </Badge>
          </IconButton>
        </Toolbar>
      </DashboardNavbarRoot>
    </>
  );
};

DashboardNavbar.propTypes = {
  onSidebarOpen: PropTypes.func,
};
